// Temps 2 de l'Inventaire des Drivers Relationnels en séance : 3 clés de compréhension (FR).

export const CLES_ORDER = ["fais_plaisir", "fais_efforts", "sois_fort", "sois_parfait", "depeche_toi"];

export const DIFFICULTE = [
  { value: 0, label: "Très facile" },
  { value: 1, label: "Facile" },
  { value: 2, label: "Moyen" },
  { value: 3, label: "Difficile" },
  { value: 4, label: "Très difficile" },
];

export const CLES = [
  {
    key: "definitions",
    num: 1,
    title: "La définition des drivers",
    intro: "Nous avons tous des drivers, appelés aussi injonctions internes : ce qui nous motive ou nous conditionne dans notre façon de faire ou de réagir dans une situation.",
    rankTitle: "Votre premier classement",
    rankText: "Classez les cinq drivers du plus présent chez vous (en haut) au moins présent (en bas). Utilisez les flèches.",
  },
  {
    key: "dimensions",
    num: 2,
    title: "Les dimensions des drivers",
    intro: "Il n'y a pas de bons ou de mauvais drivers : chaque driver a un côté positif et un côté négatif. C'est la situation qui détermine si l'on va en tirer du positif ou du négatif.",
    rankTitle: "Réajustez ou confirmez votre classement",
    rankText: "À la lumière des points positifs, négatifs et de ce dont chaque driver nous coupe, réajustez votre classement si besoin, ou confirmez-le.",
  },
  {
    key: "antidotes",
    num: 3,
    title: "Les antidotes des drivers",
    intro: "Chaque driver a un antidote pour prévenir ses aspects négatifs.",
    rankTitle: "Confirmez votre classement et évaluez les antidotes",
    rankText: "Réajustez ou confirmez une dernière fois votre classement, puis indiquez pour chaque antidote son niveau de difficulté au quotidien.",
  },
];

export const CLES_DRIVERS = {
  fais_plaisir: {
    name: "Fais plaisir",
    formulation: "« Je fais les choses pour faire plaisir aux autres, être accepté(e) et éviter de les décevoir ou d'être rejeté(e). »",
    short: "« Je dois faire plaisir aux autres pour être accepté(e) et ne pas les décevoir. »",
    positifs: ["Abnégation", "Compassion élevée", "Disponibilité"],
    negatifs: ["Difficulté à poser des limites", "Effacement de soi", "Ressentiment", "Culpabilité"],
    coupure: ["De ses besoins propres", "De son identité personnelle", "De l'authenticité relationnelle", "De l'assertivité", "Du respect de soi"],
    antidote: "Savoir dire non, ou accepter qu'on puisse nous dire non",
    antidoteShort: "Savoir dire non",
    antidoteImg: "/drivers/antidote-fais_plaisir.jpg",
    antidoteSymbole: "la barrière",
  },
  fais_efforts: {
    name: "Fais des efforts",
    formulation: "« Je fais les choses même quand c'est difficile ou que je n'en ai pas envie, parce que je pense qu'il faut travailler dur et souffrir pour réussir. »",
    short: "« Je dois faire des efforts pour mériter ma réussite. »",
    positifs: ["Résilience élevée", "Tolérance à la frustration", "Engagement durable", "Sens de l'effort", "Capacité à affronter des tâches complexes"],
    negatifs: ["Surinvestissement inutile", "Difficulté à lâcher prise", "Fatigue chronique", "Faible optimisation des ressources"],
    coupure: ["Du plaisir dans l'action", "De l'efficacité réelle", "Du repos réparateur"],
    antidote: "Savoir équilibrer",
    antidoteShort: "Savoir équilibrer",
    antidoteImg: "/drivers/antidote-fais_efforts.jpg",
    antidoteSymbole: "la balance",
  },
  sois_fort: {
    name: "Sois fort(e)",
    formulation: "« Je fais les choses seul(e) et je prends sur moi, parce que je pense que je ne peux pas compter sur les autres et que je dois être capable de me débrouiller seul(e). »",
    short: "« Je dois être fort(e) et autonome, car je ne peux pas compter sur les autres. »",
    positifs: ["Capacité à faire face à l'adversité", "Endurance psychique", "Autonomie élevée", "Résistance dans les situations de crise", "Stabilité émotionnelle apparente"],
    negatifs: ["Difficulté à exprimer ses besoins", "Isolement émotionnel", "Somatisation fréquente", "Faible demande de soutien", "Usure psychique silencieuse"],
    coupure: ["De ses émotions authentiques", "Du soutien relationnel", "De l'empathie envers soi-même", "De la capacité à demander", "De l'écoute des limites corporelles"],
    antidote: "Savoir poser des mots",
    antidoteShort: "Savoir poser des mots",
    antidoteImg: "/drivers/antidote-sois_fort.jpg",
    antidoteSymbole: "la porte",
  },
  sois_parfait: {
    name: "Sois parfait(e)",
    formulation: "« Je fais les choses le mieux possible, parce que je pense qu'il faut être irréprochable et que faire quelque chose imparfaitement n'est pas suffisant. »",
    short: "« Je dois être irréprochable pour avoir de la valeur et éviter l'erreur. »",
    positifs: ["Travail soigné et précis", "Sens aigu du détail", "Haut niveau d'exigence", "Fiabilité professionnelle", "Recherche d'amélioration continue"],
    negatifs: ["Insatisfaction chronique", "Procrastination par peur de l'imperfection", "Auto-critique excessive", "Rigidité cognitive", "Difficulté à déléguer"],
    coupure: ["De l'apprentissage par l'erreur", "Du sentiment de satisfaction", "Du positif"],
    antidote: "Savoir (se) valoriser",
    antidoteShort: "Savoir (se) valoriser",
    antidoteImg: "/drivers/antidote-sois_parfait.jpg",
    antidoteSymbole: "le miroir",
  },
  depeche_toi: {
    name: "Dépêche-toi",
    formulation: "« Je fais plusieurs choses à la fois et je cherche à aller vite, parce que j'ai besoin d'être dans l'action et que j'ai l'impression que plus j'en fais, plus je suis efficace. »",
    short: "« Je dois aller vite et faire plusieurs choses à la fois pour être efficace et ne pas perdre de temps. »",
    positifs: ["Réactivité élevée", "Dynamisme", "Capacité à gérer l'urgence", "Adaptabilité", "Mise en action rapide"],
    negatifs: ["Stress et mauvaise humeur", "Surmenage psychologique", "Utopie organisationnelle", "Difficulté à prioriser"],
    coupure: ["De la présence à soi", "De la qualité de l'attention", "De la réflexion approfondie", "De l'écoute de l'autre"],
    antidote: "Savoir prioriser",
    antidoteShort: "Savoir prioriser",
    antidoteImg: "/drivers/antidote-depeche_toi.jpg",
    antidoteSymbole: "la lanterne qui se recharge",
  },
};

export const CLES_T = {
  thanksTitle: "Merci, vos réponses ont été transmises",
  thanksText: "Vos 50 réponses ont été envoyées à votre praticien, qui en fera la lecture avec vous. Nous vous proposons maintenant trois clés de compréhension pour explorer les drivers.",
  thanksBtn: "Découvrir les 3 clés de compréhension",
  doneTitle: "Merci pour ce travail",
  doneText: "Vos réponses, vos classements et votre évaluation des antidotes ont été transmis à votre praticien. Il les reprendra avec vous en séance ; après cet échange, il pourra vous ouvrir ici un écran de résultats à votre intention.",
  doneExo: "Vous pouvez dès maintenant poursuivre avec le cahier « Travail autour des drivers relationnels » : votre classement y sera repris.",
  doneExoBtn: "Poursuivre avec le travail autour des drivers →",
  resumeNotice: "Vous reprenez là où vous vous étiez arrêté(e).",
};
